"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
class WidgetManager extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.updateDataSourceIds = this.updateDataSourceIds.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.dataSources.loaded', this.updateDataSourceIds);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.dataSources.loaded', this.updateDataSourceIds);
  }
  updateDataSourceIds() {
    this.setState({
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    });
  }
  onButtonClick() {
    if (this.props.activeSection == "octaviHighlights") {
      _ServiceLocator.default.eventManager.emit('taxi.filter.manageWidgets.request');
    }
    if (this.props.activeSection == "octaviMap") {
      _ServiceLocator.default.eventManager.emit('taxi.filter.manageMapWidget.request');
    }
  }
  render() {
    if (this.state.dataSourceIds.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__form-input-container"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "button grey",
      type: "button",
      onClick: x => this.onButtonClick()
    }, this.props.activeSection == "octaviMap" ? this.props.t('octavi:filters:mapWidget:sectionName') : this.props.t('octavi:filters:widgets:sectionName')));
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(WidgetManager);
WidgetManager.propTypes = {
  activeSection: _propTypes.default.string
};